import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import { getApiUrl } from '../../../utils/apiConfig';


const PotencialClienteDropdown = ({ selectedVisita, setSelectedVisita }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [potencialOptions, setPotencialOptions] = useState([]);

  useEffect(() => {
    const fetchPotenciales = async () => {
      try {
        const res = await axios.get(getApiUrl('/api/potencialCliente'));
        const potenciales = res.data.map((item) => ({
          value: item.PotencialCliente,
          label: item.PotencialCliente,
          color: '#eee',
        }));
        setPotencialOptions(potenciales);
      } catch (err) {
        console.error('Error al cargar potenciales de cliente:', err);
      }
    };

    fetchPotenciales();
  }, []);

  // const selected = potencialOptions.find((opt) => opt.value === selectedVisita?.PotencialCliente) || { value: '', label: '', color: '#eee' };
  const selected = {
    value: selectedVisita?.PotencialCliente || '',
    label: selectedVisita?.PotencialCliente || '',
    color: '#eee'
  };

  const placeholder = 'Selecciona potencial cliente';
  const hasSelection = Boolean((selectedVisita?.PotencialCliente || '').trim());

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Potencial Cliente*</label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="DropDownName w-full p-2 shadow-sm border rounded bg-white flex justify-between items-center"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        title={hasSelection ? selected.label : placeholder}
      >
        <span className={`truncate ${hasSelection ? '' : 'text-gray-400'}`}>
          {hasSelection ? selected.label : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto" role="listbox">
          <li
            onClick={() => { setSelectedVisita({ ...selectedVisita, PotencialCliente: '', PotencialCliente: '' }); setIsOpen(false); }}
            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors ${!hasSelection ? 'bg-blue-50 text-blue-700 font-medium' : ''}`}
            role="option"
            aria-selected={!hasSelection}
          >
            {placeholder}
          </li>
          {potencialOptions.map(option => (
            <li
              key={option.value}
              onClick={() => {
                setSelectedVisita({ ...selectedVisita, PotencialCliente: option.value, PotencialCliente: option.label });
                setIsOpen(false);
              }}
              className={classNames(
                'cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors',
                { 'bg-blue-50 text-blue-700 font-medium': (selectedVisita.PotencialCliente?.trim() || '') === option.value }
              )}
              role="option"
              aria-selected={(selectedVisita.PotencialCliente?.trim() || '') === option.value}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PotencialClienteDropdown;

